'use client';

import { SignupShell } from '../../components/SignupShell';
import { SignupErrorContent } from './SignupErrorContent';

/**
 * `/error/`: where every failure production sends to its error screen
 * lands. The member's only way on is Book a call.
 */
export function ErrorScreen() {
  return (
    <SignupShell>
      <SignupErrorContent />
    </SignupShell>
  );
}
